import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UsePlaylistsTrendingProps {
  page: number;
  limit?: number;
  date?: Date;
}

export const usePlaylistsTrending = ({ page, limit = 10, date }: UsePlaylistsTrendingProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const { countryCode } = useSMLCountryParam();
  const offset = (page - 1) * limit;

  const query = useTRPCQuery(
    trpcMusicAPI.playlists.trending.queryOptions({ date, offset, limit, countryCode }, { enabled: true })
  );

  return query;
};
